"use client";
import React from 'react'

function Now() {
  return (
    <main className="[padding-inline:_clamp(1rem,4vw,8rem)]">
      <section className="mt-5 py-4 ">
        <h1 className='text-3xl font-bold text-black dark:text-white transition-colors duration-1000'>Now - Redacted Page</h1>
        <h2>Basically a blog.</h2>
      </section>

      <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/>
      
      <section className="px-[4vw] w-full py-8 px-2 lg:flex lg:flex-row gap-8 justify-between">
          <div className="text-zinc-600 dark:text-zinc-300 transition-colors duration-1000">
            <div className="flex justify-between items-end gap-4 pb-2">
              <h1 className="text-2xl text-black dark:text-white">Interning at Amazon!</h1>
              <h2><em>July 16, 2025</em></h2>
            </div>
            <p>
              It's been 3 weeks and few days since I started my internship at Amazon! It felt like it took me a bit to fully understand exactly what my project was and how it connected with other components within the team. 
              However, I was able to get a good understanding through the help of my teammates and my mentor and by creating a point of concept. I'm feeling more confident in myself and not having as much imposter syndrome. 
              I've been working on my design document and I'm excited to get started on the coding and implementation of the project!
            </p>
          </div>
      </section>

      <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/>
      
      <section className="px-[4vw] w-full py-8 px-2 lg:flex lg:flex-row gap-8 justify-between">
          <div className="text-zinc-600 dark:text-zinc-300 transition-colors duration-1000">
            <div className="flex justify-between items-end gap-4 pb-2">
              <h1 className="text-2xl text-black dark:text-white">Things I'm Excited About</h1>
              <h2><em>May 3, 2025</em></h2>
            </div>
            <p>
              As it's getting closer to summer, I'm constantly having to think about things that I am excited about to get me through the quarter.
              One of the big things I am excited about for this summer is obviously my internship at Amazon, but I'm also excited to have a whole routine and 
              focus on myself and my fitness and eating goals. For now, I'm looking forward to some simple things like doing my oil change for my car and also 
              doing the puzzle test study in a week. I'm also going to go on a Yosemite trip with friends so I'm also excited for that.
            </p>
            <br></br>
            <p>
              I've also really been thinking about how I just want a delicious car. I know that means I need a place for the car and also to afford insurance. 
              I really like going on drives randomly and driving myself. Especially those night drives where you can just drive and listen to music and think about life.
              But if I had a delicious car (like the Supra), imagine the engine sounds and power I could feel. And also seeing other cool cars on the road and they 
              would give me respect too. Whenever I see Supras on the road, they always make my day so I think I could provide that to other car lovers out there. 
              Recently I saw a Supra at Kate Sessions park and I left a MK4 Supra sticker on the window and the owner messaged me on Instagram saying it made his day, 
              which made me feel good. For now, I have the Corolla and I'm actually getting coilovers for it in about 4-5 weeks. I ordered the BC Racing DS Series 
              coilovers but I didn't know they were a custom order, which means there is a 4-5 week lead time. I'm still excited to get them and put them on but 
              it's still a whiles away.
            </p>
          </div>
      </section>

      <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/>

      <section className="px-[4vw] w-full py-8 px-2 lg:flex lg:flex-row gap-8 justify-between">
          <div className="text-zinc-600 dark:text-zinc-300 transition-colors duration-1000">
            <div className="flex justify-between items-end gap-4 pb-2">
              <h1 className="text-2xl text-black dark:text-white">My Tech Stack</h1>
              <h2><em>January 25, 2025</em></h2>
            </div>
            <p>
              The new Samsung S25 line just came out and I upgraded from the S21 to the S25 Ultra for my birthday! I'm excited to use the delicious camera 
              and the new AI features. Apparently they're going to make the AI features subscription based at the end of 2025 which is a bit 
              disappointing. The reason why I have an iPad and Macbook is because I feel like they are the best for doing work on since they are so simple.
            </p>
            <br></br>
            <ul>
                <li>Galaxy S25 Ultra</li>
                <li>Galaxy Buds 3 Pro</li>
                <li>Galaxy Watch 6 Classic</li>
                <li>iPad Pro 11in (3rd Generation)</li>
                <li>Macbook Pro M3 Pro</li>
            </ul>
            
          </div>
      </section>

      <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/>

      <section className="px-[4vw] w-full py-8 px-2">
        <div className="lg:flex lg:flex-row gap-8 justify-between">
          <div className="text-zinc-600 dark:text-zinc-300 transition-colors duration-1000">
          <div className="flex justify-between items-end gap-4 pb-2">
              <h1 className="text-2xl text-black dark:text-white">Exploring Small Business</h1>
              <h2><em>January 24, 2025</em></h2>
            </div>
            <p>
              Recently I've been doing lots of research about how different small business side hustles work. One that I'm particularly interested 
              in is car detailing. I've been practicing by detailing cars for friends and family and learning about the different tools and methods. 
              I've also looked into trash bin cleaning, where I would clean trash cans for people after the trash day. I think this would be easier to 
              get customers for and it could lead me to getting detailing customers. Another thing that I have been looking into is sticker or enamel pin 
              selling, where I create my own designs and sell the stickers or pins. I think researching these different things help me understand more parts 
              of how the businesses work and I think I can use the knowledge I get from my business classes.
            </p>
          </div>
        </div>
      </section>

      <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/>


      <section className="px-[4vw] w-full py-8 px-2">
        <div className="lg:flex lg:flex-row gap-8 justify-between">
          <div className="text-zinc-600 dark:text-zinc-300 transition-colors duration-1000">
          <div className="flex justify-between items-end gap-4 pb-2">
              <h1 className="text-2xl text-black dark:text-white">Staying Active</h1>
              <h2><em>January 24, 2025</em></h2>
            </div>
            <p>
              Last year I was able to reach my gym goal of hitting 225 pounds on bench press. This year, my goal is to be able to hold a front lever 
              for at least 5 seconds. I like calisthenics in that you can display your strength without any equipment. I also want to be able to improve my 
              muscle up so that I don't swing as much. I also like to play different sports and I'd say that I can pick them up pretty quickly. Recently I've been 
              playing a bit of pickleball because it is pretty simple and doesn't require too much physical effort. Last quarter I played intramural flag football and 
              I learned a lot about football routes. I also was able to use my agility and speed to make some delicious plays during the games.
            </p>
          </div>
        </div>
      </section>

      <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/>

      <section className="px-[4vw] w-full py-8 px-2">
        <div className="lg:flex lg:flex-row gap-8 justify-between">
          <div className="text-zinc-600 dark:text-zinc-300 transition-colors duration-1000">
          <div className="flex justify-between items-end gap-4 pb-2">
              <h1 className="text-2xl text-black dark:text-white">Gaming</h1>
              <h2><em>January 24, 2025</em></h2>
            </div>
            <p>
              The game I probably spend the most time on right now is Brawl Stars. I'm just grinding to get a lot of my brawlers to 1000 trophies, max rank. 
              My favorite game mode is heist and my favorite brawler is Brock, which is the only brawler I have maxed mastery for right now.
              Another game I have is Pokemon TCG Pocket, but I feel like there isn't too much content to play and I only get on to open my packs.
              I also have been trying out Marvel Rivals but I'm getting horrible frame drops, making it unplayable.
            </p>
          </div>
        </div>
      </section>

      <hr className="w-48 h-1 mx-auto my-2 bg-gray-700 border-0 rounded md:my-10"/>

      <section className="px-[4vw] w-full py-8 px-2">
        <div className="lg:flex lg:flex-row gap-8 justify-between">
          <div className="text-zinc-600 dark:text-zinc-300 transition-colors duration-1000">
          <div className="flex justify-between items-end gap-4 pb-2">
              <h1 className="text-2xl text-black dark:text-white">Cars!</h1>
              <h2><em>January 24, 2025</em></h2>
            </div>
            <p>
              I drive a 2024 Corolla Hatchback, which I think is pretty cool. It is a econobox so it doesn't have good power, but it handles well and is zippy on corners. 
              I like to add mods to my car such as the exhaust and cosmetic mods like the spoiler wing and sequential taillights. It helps me learn more about the car 
              and I like to do so because it's very hands on. My current dream car is the Toyota Supra, and I was sad to see that the A90 Supra was being disconutinued 
              since I liked how much power the BMW B58 engine was able to unlock with tuning and mods.
            </p>
          </div>
        </div>
      </section>
      
      
      
    </main>
  )
}

export default Now